export const listCheckboxAtributos = [
  { value: 42, label: 'Cantidad' },
  { value: 58, label: 'Sección' },
  { value: 54, label: 'Fecha de publicación' },
  { value: 15, label: 'Tipo de medida' },
  { value: 53, label: 'Página' },
  { value: 63, label: 'Información adicional' },
  { value: 65, label: 'Nombre' },
  { value: 51, label: 'Leyenda de inserción pagada' },
  { value: 50, label: 'Grupo editorial' },
  { value: 47, label: 'Responsable del pago' }
];

export const listCheckboxHallazgos = [
  { value: 9, label: 'ID INE' },
  { value: 30, label: 'Colonia' },
  { value: 34, label: 'Referencia de ubicación' },
  { value: 42, label: 'Cantidad' },
  { value: 31, label: 'C. P.' },
  { value: 44, label: 'Lema' },
  { value: 15, label: 'Tipo de medida' },
  { value: 32, label: 'Entre calle' },
  { value: 25, label: 'Duración' }, // 24, 25 y 26 van juntos
  { value: 18, label: 'Medida' },
  { value: 33, label: 'Y calle' },
  { value: 45, label: 'Placas' },
  { value: 28, label: 'Calle' },
  { value: 27, label: 'Municipio' },
  { value: 39, label: 'Propaganda de proceso anterior' },
  { value: 29, label: 'Número' },
  { value: 10, label: 'Entidad' },
  { value: 63, label: 'Información adicional' }
];
